var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "nameError",
                        placeholder: "Enter Name",
                        type: "text"
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.nameError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postcode,
                          expression: "postcode"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "postcode",
                        placeholder: "Enter Postcode",
                        type: "number"
                      },
                      domProps: { value: _vm.postcode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.postcode = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.postcodeError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.latitude,
                          expression: "latitude"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "latitude",
                        placeholder: "Enter Langitude",
                        type: "number"
                      },
                      domProps: { value: _vm.latitude },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.latitude = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.latitudeError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.longitude,
                          expression: "longitude"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "longitude",
                        placeholder: "Enter Longitude",
                        type: "number"
                      },
                      domProps: { value: _vm.longitude },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.longitude = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.longitudeError))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdatePostcode()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdatePostcode((_vm.flag = "Save and Continue"))
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Postcode :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Latitude :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Longitude : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bd7e436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd7e436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/postcode/AddUpdatePostcode.vue
// module id = null
// module chunks = 